"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNestedTooltip = exports["default"] = exports.Tooltip = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _cccisdFormik = require("cccisd-formik");
var _tooltip = _interopRequireDefault(require("./tooltip.svg"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _md = _interopRequireDefault(require("md5"));
require("./style.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var validate = function validate(values) {
  var errors = {};
  if (!values.tooltip || !values.tooltip.trim()) {
    errors.tooltip = 'Tooltip is required';
  }
  if (!values.text || !values.text.trim()) {
    errors.text = 'Text is required';
  }
  return errors;
};
var isNestedTooltip = exports.isNestedTooltip = function isNestedTooltip(selectedContent) {
  return selectedContent.includes(' data-tooltip=') && (!/^<span[^>]*data-tooltip=.*<\/span>$/.test(selectedContent) || selectedContent.match(/ data-tooltip=/g).length > 1);
};
var Tooltip = exports.Tooltip = /*#__PURE__*/function (_React$Component) {
  function Tooltip() {
    var _this;
    _classCallCheck(this, Tooltip);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Tooltip, [].concat(args));
    _defineProperty(_this, "getInitialValues", function () {
      var _this$props = _this.props,
        selectedContent = _this$props.selectedContent,
        meta = _this$props.meta;
      var result = selectedContent.match(/^<span[^>]*data-tooltip="([^"]*)"[^>]*>([^<]*)<\/span>$/);
      if (result && meta.tooltips && meta.tooltips[result[1]]) {
        return {
          tooltip: meta.tooltips[result[1]].text,
          text: result[2]
        };
      }
      return {
        tooltip: '',
        text: selectedContent
      };
    });
    _defineProperty(_this, "onSubmit", function (values) {
      var tooltip = values.tooltip,
        text = values.text;
      var hash = (0, _md["default"])("".concat(new Date().getTime(), "_").concat(Math.random())).substr(0, 5);
      var code = hash;
      var meta = _objectSpread(_objectSpread({}, _this.props.meta), {}, {
        tooltips: _objectSpread(_objectSpread({}, _this.props.meta.tooltips), {}, _defineProperty({}, code, {
          text: tooltip
        }))
      });
      _this.props.insertContent("<span data-tooltip=\"".concat(code, "\" class=\"cccisd-wysiwyg-tooltip mceNonEditable\">").concat(text, "</span>"), meta);
    });
    _defineProperty(_this, "removeTooltip", function () {
      var initialValues = _this.getInitialValues();
      _this.props.insertContent(initialValues.text);
    });
    _defineProperty(_this, "isWordTimings", function () {
      return (0, _get2["default"])(_this.props, 'meta.audio.wordTimings');
    });
    _defineProperty(_this, "getError", function () {
      if (isNestedTooltip(_this.props.selectedContent)) {
        return 'You cannot use nested tooltips';
      }
      if (_this.isWordTimings()) {
        return 'You cannot use tooltips along with word timings';
      }
      return null;
    });
    return _this;
  }
  _inherits(Tooltip, _React$Component);
  return _createClass(Tooltip, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var error = this.getError();
      if (error) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "alert alert-danger",
          style: {
            margin: 0
          }
        }, error);
      }
      var initialValues = this.getInitialValues();
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
        initialValues: initialValues,
        onSubmit: this.onSubmit,
        validate: validate,
        render: function render() {
          return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "text",
            component: _cccisdFormik.CccisdInput,
            label: "Text"
          }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "tooltip",
            component: _cccisdFormik.CccisdTextarea,
            label: "Tooltip",
            autoFocus: true
          }), /*#__PURE__*/_react["default"].createElement("div", {
            style: {
              display: 'flex',
              justifyContent: 'space-between'
            }
          }, /*#__PURE__*/_react["default"].createElement("button", {
            className: "btn btn-primary",
            type: "submit"
          }, "Submit"), initialValues.tooltip && /*#__PURE__*/_react["default"].createElement("button", {
            className: "btn btn-warning",
            type: "button",
            onClick: _this2.removeTooltip
          }, "Remove tooltip")));
        }
      });
    }
  }]);
}(_react["default"].Component);
_defineProperty(Tooltip, "propTypes", {
  content: _propTypes["default"].string,
  meta: _propTypes["default"].object,
  setContent: _propTypes["default"].func,
  insertContent: _propTypes["default"].func,
  selectedContent: _propTypes["default"].string,
  closeModal: _propTypes["default"].func
});
var _default = exports["default"] = {
  name: 'cccisdTooltip',
  image: _tooltip["default"],
  tooltip: 'Tooltip',
  title: 'Tooltip',
  component: Tooltip,
  activeCondition: function activeCondition(element) {
    return element.className === 'cccisd-wysiwyg-tooltip';
  },
  disableCondition: function disableCondition(content, meta, currentElement, selection) {
    return selection.length === 0;
  }
};